<div class="resp-tabs-container min-content-height">
    <div id="reviewContent" class="reviewContent">
        <div class="reviewSection">
            <div class="row">
                <div class="col-3">
                    <div class="tm-logo"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <div class="serviceTitle fontUltr style2">{{authoringContentData?.changeService?.changeServiceTxt}}</div>
                    <div class="lineNo fontHalb style5">{{authoringContentData?.changeService?.lineTxt}}{{subscriberData?.msisdn | msisdn}}</div>
                    <div class="serviceUserName">{{lineDetails?.lineIdentifier?.udf1}}</div>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                    <div class="servicePlan fontHalb style6">{{subscriberData?.subscriber?.subscriberInfo?.pricePlanDescription}}</div>
                    <div class="servicePlanLabel">{{authoringContentData?.changeService?.planTxt}}</div>
                  </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <div class="reviewTitle serviceTitle fontUltr style2">{{authoringContentData?.reviewChangeService?.reviewTxt}}</div>
                    <div class="row">
                        <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                            <div class="subTitle parallelPadding heading chooseServiceHeading customize-service style4">
                                {{authoringContentData?.reviewChangeService?.yourServicesTxt}}
                            </div>
                        </div>
                    </div>
                  <div class="row">
                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                      <div >
                        {{authoringContentData?.reviewChangeService?.yourServicesDesc}}
                      </div>
                    </div>
                  </div>
                  <div class="borderLine" *ngIf="effectiveTodayService?.length>0"></div>
                  <div class="row" *ngIf="effectiveTodayService?.length>0">
                    <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                        <div class="addedUnchanged">
                            {{authoringContentData?.reviewChangeService?.addedText}} ({{effectiveTodayService?.length}})
                        </div>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                        <div class="floatRight">
                            <span class="changesTakeEffect">{{authoringContentData?.reviewChangeService?.changesEffectTxt}}</span>
                            <span class="nextDate">({{currentPSTDate | date: 'MMMM d, y'}})</span>
                        </div>
                    </div>
                </div>
                  <div class="serviceRow" *ngFor="let service of effectiveTodayService; let i=index">
                    <div class="row" *ngIf="service?.effectiveToday">
                      <div class="col-1">
                        <img src="/assets/tfb-acctmgmt/images/checkmarkfilled.svg" class="greenTick" alt="">
                      </div>
                      <div class="col-11">
                        <div class="row">
                          <div class="col-10">
                            <span class="serviceName">{{service.name ? service.name : service.description}}</span>
                          </div>
                          <div class="col-2">
                                        <span class="fontUltr6 float-right">{{service.price && service.price!== '0.0' ? (service.price | currency) +'/mo.' :
                                            'Free'}}
                                        </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="borderLine"></div>
                    <div class="addedUnchanged" *ngIf="effectiveNextBillCycleService?.length>0"></div>
                    <div class="row" *ngIf="effectiveNextBillCycleService?.length>0">
                        <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                            <div class="addedUnchanged">
                                {{authoringContentData?.reviewChangeService?.addedUnchangedText}} ({{effectiveNextBillCycleService?.length}})
                            </div>
                        </div>
                        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                            <div class="floatRight">
                                <span class="changesTakeEffect">{{authoringContentData?.reviewChangeService?.changesEffectTxt}}</span>
                                <span class="nextDate">{{authoringContentData?.reviewChangeService?.nextBillingTxt}} ({{displayBillingDateInReviewScreen}})</span>
                            </div>
                        </div>
                    </div>
                    <div class="serviceRow" *ngFor="let service of effectiveNextBillCycleService; let i=index">
                        <div class="row" *ngIf="!service?.effectiveToday">
                            <div class="col-1">
                                <img src="/assets/tfb-acctmgmt/images/checkmarkfilled.svg" class="greenTick" alt="">
                            </div>
                            <div class="col-11">
                                <div class="row">
                                    <div class="col-10">
                                        <span class="serviceName">{{service.name ? service.name : service.description}}</span>
                                    </div>
                                    <div class="col-2">
                                        <span class="fontUltr6 float-right">{{service.price && service.price!== '0.0' ? (service.price | currency) +'/mo.' :
                                            'Free'}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </div>
                        <div class="borderLine"></div>
                    <div class="row" *ngIf="removedServicesfromStorage?.length>0">
                      <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                        <div class="addedUnchanged">
                          {{authoringContentData?.reviewChangeService?.removedText}} ({{removedServicesfromStorage?.length}})
                        </div>
                      </div>
                      <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                        <div class="floatRight">
                          <span class="changesTakeEffect">{{authoringContentData?.reviewChangeService?.changesEffectTxt}}</span>
                          <span class="nextDate">{{authoringContentData?.reviewChangeService?.nextBillingTxt}} ({{displayBillingDateInReviewScreen}})</span>
                        </div>
                      </div>
                    </div>
                        <div class="serviceRow" *ngFor="let service of removedServicesfromStorage; let i=index">
                            <div class="row">
                                <div class="col-1">
                                    <img src="/assets/tfb-acctmgmt/images/minus.svg" class="grayIcon ml-0" alt="">
                                </div>
                                <div class="col-11">
                                    <div class="row">
                                        <div class="col-10">
                                            <span class="serviceName">{{service.name ? service.name : service.description}}</span>
                                        </div>
                                        <div class="col-2">
                                            <span class="fontUltr6 float-right serviceRemovedPrice">{{service.price && service.price!== '0.0' ? (service.price | currency) +'/mo.'
                                                : 'Free'}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class='promotionRemoved' *ngIf ="promotionLists?.length > 0">
                        <div class='body_bold'>{{authoringContentData?.reviewChangeService?.promotionLabel}}</div>
                        <div class='promotionList'>
                            <ul class="promoDescList">
                               <li class="promotionListValue" [attr.Soc]="promo.soc" *ngFor="let promo of promotionLists">
                                      {{promo.desc}}
                               </li>
                            </ul>
                        </div>
                        <div class='body_bold promoStaticTxt'>{{authoringContentData?.reviewChangeService?.promoStaticText}}</div>
                    </div>

                    <div class="serviceTotal">
                        <div class="hidden-xs serviceName">
                            {{authoringContentData?.reviewChangeService?.expServicesTotalTxt}}
                            <span class="totalPrice  fontUltr6">{{currentServicesTotal | currency}}.</span>
                            <br>
                            <span class="serviceTotalSubText">
                                <span class="oldMonthlyTotal float-right">{{authoringContentData?.reviewChangeService?.taxesAndFeesTxt}}</span>
                                <br>
                                <span class="oldMonthlyTotal">{{authoringContentData?.reviewChangeService?.previousTotalText}}{{' '}}</span>
                                <span class="oldTotalPrice ">{{previousServicesTotal | currency}}.</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isSpectrumBarterBan" class="row">
                    <div class="col-1 col-sm-1 col-lg-1 col-md-1 checkBoxstyle">
                        <div class="checkbox checkbox-primary checkbox-terms">
                            <mat-checkbox id='termscheckbox' class="padding-checkbox" (change)="isServicesEdited();callServiceAgreementAndTerms()"></mat-checkbox>
                            <label for="termsCheckbox"> </label>
                        </div>
                    </div>
                    <div class="col-xs-11 col-11 col-sm-11 col-lg-11 col-md-11 termsPadding">
                        <div id="termsConditions">
                            {{authoringContentData?.reviewChangeService?.agreeAndSubmitMsg}}
                            <a class="service_agreement" tabindex="0" href="javascript:void(0)" (click)="ServiceAgreement(false)">
                                <span class="link_color">{{authoringContentData?.reviewChangeService?.serviceAgreementTxt}}</span>
                            </a>{{authoringContentData?.reviewChangeService?.termsSpecificMsg}}
                            <a class="terms_conditions" tabindex="0" target="_blank" href="{{authoringContentData?.footer?.termsAndConditionUrl}}" rel="noopener" >
                                <span class="link_color">{{authoringContentData?.reviewChangeService?.termsAndConditionText}}</span>
                            </a>{{authoringContentData?.reviewChangeService?.termsMessageText}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-changeservices-sticky-footer [isServiceChanged]="isSubmitEnable" [previousServicesTotal]="previousServicesTotal" [currentServicesTotal]="currentServicesTotal"
[ratePlansAddedList]="addedServicesfromStorage" [ratePlansRemovedList]="removedServicesfromStorage"></app-changeservices-sticky-footer>
